export enum RiskProfileType {
  ConservativeIncome = 'ConservativeIncome',
  ModerateGrowth = 'ModerateGrowth',
  BalancedGrowth = 'BalancedGrowth',
  AggressiveGrowth = 'AggressiveGrowth',
  SpeculativeGrowth = 'SpeculativeGrowth',
}
